import React from 'react'

import Button from '../../../shared/components/atoms/button/button'
import logoSpotify from '../../../assets/images/logoSpotify.png'

import './bannerSpotify.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const BannerSpotify = () => {
  const url =
    'https://open.spotify.com/playlist/31r090vFXyDAohnJ5txLSX?si=bfceeca3d38e467a'
  return (
    <div className="f-bannerSpotify-container" id="spotify">
      <div id="mundoCurV" className="f-bannerSpotify-container__ancla" />
      <div className="f-bannerSpotify-container__content">
        <div className="f-bannerSpotify-container__content__info">
          <img
            src={logoSpotify}
            alt="icono spotify"
            className="f-bannerSpotify-container__content__info__logoSpotify"
          />
          {['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE) ? (
            <p>
              En esos días de menstruación todas queremos música especial y por
              eso, hicimos una playlist que te va a encantar.
            </p>
          ) : (
            <p>
              En esos días de menstruación todas queremos música especial, y por
              eso, hicimos una playlist que te encantará.
            </p>
          )}

          <Button
            title="Escuchar playlist"
            className="new-primary-pink short buttonSpotify"
            onClick={() => {
              pushEventDataLayer(
                'Interacciones - Playlist',
                'Cur-v',
                'Click',
                'Escuchar Playlist'
              )
              window.open(url, '_blank')
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default BannerSpotify
